import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="share-patterns--form"
export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.updateBreadcrumb();
  }

  updateBreadcrumb() {
    const code = this.formTarget.querySelector(`input[name$="[code]"]`).value;
    const name = this.formTarget.querySelector(`input[name$="[name]"]`).value;
    const breadcrumbText = `${code} ${name}`;

    document.querySelector(".master-page .crumb").innerHTML = `マスタ ＞ 共用 ＞ ${breadcrumbText}`;
  }
}

